exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-expansion-panel-content__wrap{padding:0 4px 4px;flex:1 1 auto;max-width:100%}", ""]);

// exports
